<div class="confirm-modal ig-modal category-link-modal">
  <div class="close-button">
    <mat-icon (click)="close()">clear</mat-icon>
  </div>
  <div class="title">Category Link</div>

  <div class="info-body">
    <div>
      <div class="mb-10">Place widget:
        <mat-icon (click)="copyLink()">
          content_copy
        </mat-icon>
      </div>
      <div class="code-area">
        <pre>
          <code>{{link}}</code>
        </pre>
      </div>
    </div>
    <div>
      <div class="my-10">JSON feed API:
        <mat-icon (click)="copyJsonApi()">
          content_copy
        </mat-icon>
      </div>
      <div class="code-area">
        <pre>
          <code>
            {{jsonApi}}
          </code>
        </pre>
      </div>
    </div>
  </div>

  <div class="cancel-btn pointer" (click)="close()">
    Close
  </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/show.category.link.modal/show.category.link.modal.component.html